import { Link } from 'react-router-dom';
import styles from './styles.module.scss';

export type SubMenus = {
  content: string;
  link: string;
  isExternal?: boolean;
}[];

type Props = {
  subMenus: SubMenus;
};

/**
 * サブメニューリストコンポーネント
 *
 * @param subMenus サブメニューのリスト
 * @returns サブメニューリストコンポーネント
 */
export const SubMenuList: React.FC<Props> = ({ subMenus }) => (
  <ul className={styles.SubMenuList}>
    {subMenus.map(({ content, link, isExternal }, index) => (
      <li key={`sidemenu-subitem-${index}`}>
        <Link
          to={link}
          target={isExternal ? '_blank' : undefined}
          className={styles.SubMenuList__Subitem}
        >
          <span className={styles.SubMenuList__Subitem__Content}>{content}</span>
        </Link>
      </li>
    ))}
  </ul>
);
